export default __webpack_public_path__ + "static/media/property_1_22.e00fc025.webp";